<form [formGroup]="protocolForm" (ngSubmit)="submitProtocol()" class="p-fluid">
  <!-- İlgili Kişi (userId) Seçimi -->
  <div class="form-group">
    <p-floatLabel>
      <p-dropdown
        [options]="users"
        optionLabel="fullName"
        optionValue="userId"
        placeholder="Person auswählen"
        formControlName="userId"
        appendTo="body"
        [showClear]="true"
      ></p-dropdown>
      <label for="userId">Interessent </label>
    </p-floatLabel>
  </div>

  <!-- PDF Yükleme -->
  <div class="form-group">
    <p-fileUpload
      name="uploadedPdf"
      mode="basic"
      chooseLabel="PDF hochladen"
      accept=".pdf"
      (onSelect)="onFileSelected($event)"
      [auto]="false"
      maxFileSize="10000000"
    ></p-fileUpload>
  </div>

  <!-- Kaydet / İptal Butonları -->
  <div class="form-buttons">
    <button
      pButton
      aria-label="Speichern"
      label="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!protocolForm.valid || !selectedPdfFile"
    ></button>

    <button
      pButton
      aria-label="Abbrechen"
      label="Abbrechen"
      icon="pi pi-times"
      type="button"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
